import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import produce from 'immer';
import { Form } from '@rocketseat/unform';
import { MdSearch, MdFilterList, MdArrowBack } from 'react-icons/md';

import {
  Button,
  WrapperFlex,
  Title,
  Breadcrumbs,
  SearchBox,
} from '@unimed-fesp/components';

import FadeIn from '../../components/atoms/FadeIn';

import TableDocumentos from '../../components/organisms/TableDocumentos';
import ModalDetalheDocumento from '../../components/organisms/ModalDetalheDocumento';
import ModalMotivoRecusa from '../../components/organisms/ModalMotivoRecusa';
import ModalSuccess from '../../components/organisms/ModalSuccess';

import { Container } from './styles';

import { Creators as BeneficiarioActions } from '../../store/ducks/beneficiario';

import theme from '../../styles/theme';
import history from '../../services/history';

const { REACT_APP_MOVCAD_LEGACY } = process.env;

function DetalheDocumentos({ match }) {
  const {
    patchDocumentoConferencia,
    getDocumentosStatus,
    getDocumentoDetalhe,
  } = useSelector((state) => state.beneficiario);

  const dispatch = useDispatch();
  const { idLista } = match.params;

  const paginationPageParams = {
    pageNumber: 1,
    pageSize: 10,
    nextPage: null,
    previousPage: null,
    totalPages: null,
  };

  const filterPageParams = {
    idLista,
    nomeBeneficiario: null,
  };

  const [openModalDetalheDocumento, setOpenModalDetalheDocumento] = useState({
    isOpen: false,
    paramsRequest: null,
    idBeneficiario: null,
    tipoDocumento: null,
    statusDocumento: null,
  });
  const [openModalMotivoRecusa, setOpenModalMotivoRecusa] = useState({
    isOpen: false,
    idArquivo: null,
  });
  const [paginationParams, setPaginationParams] = useState(
    paginationPageParams
  );
  const [filterParams, setFilterParams] = useState(filterPageParams);
  const [inputValue, setInputValue] = useState('');
  const [openModalSuccess, setOpenModalSuccess] = useState({
    success: false,
    message: '',
  });

  function handleData(data) {
    const newFilterParams = produce(filterParams, (draft) => {
      draft.nomeBeneficiario = inputValue;
    });

    const newPaginationParams = produce(paginationParams, (draft) => {
      draft.pageNumber = 1;
      draft.pageSize = 10;
    });

    const params = {
      ...newFilterParams,
      ...newPaginationParams,
    };

    setFilterParams(newFilterParams);
    setPaginationParams(newPaginationParams);
    return params;
  }

  function handleSubmit(data) {
    const params = handleData(data);
    dispatch(BeneficiarioActions.getDocumentosStatusRequest(params));
  }

  function handleInputChange(e) {
    setInputValue(e.target.value);
  }

  function handlePageChangeKeyDown(e) {
    if (e.keyCode === 13) {
      const params = {
        ...filterParams,
        ...paginationParams,
      };

      if (paginationParams.pageNumber !== '')
        dispatch(BeneficiarioActions.getDocumentosStatusRequest(params));
    }
  }

  function handleSelectedPageSize(e) {
    const newPageSize = produce(paginationParams, (draft) => {
      draft.pageSize = e.target.dataset.text;
      draft.pageNumber = 1;

      return draft;
    });
    const params = {
      ...filterParams,
      ...newPageSize,
    };

    dispatch(BeneficiarioActions.getDocumentosStatusRequest(params));

    setPaginationParams(newPageSize);
  }

  function handlePageChange(e) {
    const newPageAtual = produce(paginationParams, (draft) => {
      draft.pageNumber = e.target.value;

      return draft;
    });

    if (
      newPageAtual.totalPages >= newPageAtual.pageNumber &&
      newPageAtual.pageNumber !== '0'
    )
      setPaginationParams(newPageAtual);
  }

  function handleNextPage() {
    const newPageAtual = produce(paginationParams, (draft) => {
      if (draft.totalPages !== draft.pageNumber) draft.pageNumber += 1;

      return draft;
    });

    const params = {
      ...filterParams,
      ...newPageAtual,
    };
    if (paginationParams.totalPages !== paginationParams.pageNumber)
      dispatch(BeneficiarioActions.getDocumentosStatusRequest(params));

    setPaginationParams(newPageAtual);
  }

  function handlePreviousPage() {
    const newPageAtual = produce(paginationParams, (draft) => {
      if (draft.pageNumber > 1) draft.pageNumber -= 1;

      return draft;
    });
    const params = {
      ...filterParams,
      ...newPageAtual,
    };

    if (paginationParams.pageNumber !== 1)
      dispatch(BeneficiarioActions.getDocumentosStatusRequest(params));

    setPaginationParams(newPageAtual);
  }

  function handleChangePage(paramsPag) {
    const params = {
      ...filterParams,
      ...paramsPag,
    };

    dispatch(BeneficiarioActions.getDocumentosStatusRequest(params));
  }

  function handleModalDetalheDocumento(
    idArquivo,
    idListaAtual,
    idBeneficiario,
    idMovimentacao,
    tipoDocumento,
    statusDocumento
  ) {
    dispatch(BeneficiarioActions.getDocumentoDetalheRenew());

    const paramsRequest = {
      idLista: idListaAtual,
      idMovimentacao,
      idArquivo,
    };

    setOpenModalDetalheDocumento({
      isOpen: !openModalDetalheDocumento.isOpen,
      paramsRequest,
      idBeneficiario,
      tipoDocumento,
      statusDocumento,
    });
  }

  function handleOpenModalDetalheDocumento() {
    setOpenModalDetalheDocumento({
      isOpen: !openModalDetalheDocumento.isOpen,
    });
  }

  function handleModalMotivoRecusa() {
    handleOpenModalDetalheDocumento();

    setOpenModalMotivoRecusa({
      isOpen: !openModalMotivoRecusa.isOpen,
      idArquivo: openModalDetalheDocumento?.paramsRequest?.idArquivo,
    });
  }

  function handleOpenModalMotivoRecusa() {
    setOpenModalMotivoRecusa({
      isOpen: !openModalMotivoRecusa.isOpen,
    });
  }

  function redirectToDetalheLista() {
    window.location.replace(
      `${REACT_APP_MOVCAD_LEGACY}/CadastrarLista.aspx?idLista=${idLista}`
    );
  }

  function handleAceitarDocumento() {
    const params = {
      idArquivo: openModalDetalheDocumento?.paramsRequest?.idArquivo,
      statusConferencia: 'Aceito',
    };
    dispatch(BeneficiarioActions.patchDocumentoConferenciaRequest(params));
  }

  function handleAceitarRecusarDoc(params) {
    dispatch(BeneficiarioActions.patchDocumentoConferenciaRequest(params));
  }

  function getDocumentos() {
    const params = {
      idLista,
      ...paginationParams,
    };

    dispatch(BeneficiarioActions.getDocumentosStatusRequest(params));
  }

  function handleModalSuccess() {
    setOpenModalSuccess({
      success: !openModalSuccess.success,
    });

    if (patchDocumentoConferencia.success) {
      dispatch(BeneficiarioActions.patchDocumentoConferenciaRenew());
    }

    getDocumentos();
  }

  const filterBeneficiarios = useCallback((beneficiarios) => {
    if (!beneficiarios || beneficiarios.length <= 0) return [];

    const beneficiariosFiltrados = beneficiarios
      .map((beneficiario) => beneficiario.beneficiario)
      .filter((beneficiario) => {
        return beneficiario.documentos.length > 0;
      });

    return beneficiariosFiltrados;
  }, []);

  useEffect(() => {
    const params = {
      idLista,
      ...paginationParams,
    };

    dispatch(BeneficiarioActions.getDocumentosStatusRequest(params));
  }, []);

  useEffect(() => {
    if (patchDocumentoConferencia.success) {
      setOpenModalDetalheDocumento({
        isOpen: false,
      });
      setOpenModalMotivoRecusa({
        isOpen: false,
      });
      setOpenModalSuccess({
        success: !openModalSuccess.success,
        message: openModalDetalheDocumento.isOpen
          ? 'Documento aceito com sucesso.'
          : 'Documento recusado com sucesso.',
      });
    }
  }, [patchDocumentoConferencia.success]);

  useEffect(() => {
    if (openModalDetalheDocumento.paramsRequest)
      dispatch(
        BeneficiarioActions.getDocumentoDetalheRequest(
          openModalDetalheDocumento.paramsRequest,
          openModalDetalheDocumento.idBeneficiario
        )
      );
  }, [
    dispatch,
    openModalDetalheDocumento.idBeneficiario,
    openModalDetalheDocumento.paramsRequest,
  ]);

  return (
    <Container>
      <FadeIn>
        <WrapperFlex justifyStart alignStart column>
          <WrapperFlex fullWidth justifySpaceBetween alignStart>
            <Title
              text={
                getDocumentosStatus.response.lista
                  ? `documentos da lista: ${getDocumentosStatus.response.lista.nomeLista}`
                  : 'documentos da lista:'
              }
              fontSize={34}
              color={theme.titleGray}
              marginBottom={8}
            />{' '}
            <WrapperFlex
              percentageWidth={30}
              justifyEnd
              alignCenter
              marginSides={10}
              flexWrap
            >
              <Button
                tipo="primary"
                paddingTop={10}
                paddingRight={10}
                paddingBottom={10}
                paddingLeft={10}
                justifySpaceBetween
                alignCenter
                width={170}
                font="16px unimed_slabregular"
                onClick={() => redirectToDetalheLista(idLista)}
              >
                <MdArrowBack color="#FFFF" />
                voltar para lista
              </Button>
            </WrapperFlex>
          </WrapperFlex>
          <Breadcrumbs
            crumbs={[
              { path: 'novo' },
              { path: 'lista', onNavigate: () => history.push('/novo/lista') },
              {
                path: 'detalhe documentos',
                onNavigate: () =>
                  history.push(`/novo/lista/${idLista}/detalhe-documentos`),
              },
            ]}
          />
        </WrapperFlex>
        <Form onSubmit={handleSubmit}>
          <WrapperFlex justifyStart alignStart row>
            <SearchBox
              placeholder="Pesquise por nome do beneficiário"
              onChange={handleInputChange}
              value={inputValue}
              hideButtonFilter
              IconFilter={MdFilterList}
              IconSearch={MdSearch}
            />
          </WrapperFlex>
        </Form>
        <WrapperFlex marginTop={25} justifyStart alignStart row>
          <TableDocumentos
            idLista={idLista}
            loading={getDocumentosStatus.loading}
            headers={getDocumentosStatus.response?.header}
            beneficiarios={filterBeneficiarios(
              getDocumentosStatus.response?.beneficiarios?.data
            )}
            handleModalDetalheDocumento={handleModalDetalheDocumento}
            pageData={{
              pageNumber:
                getDocumentosStatus.response?.beneficiarios?.pageNumber,
              pageSize: getDocumentosStatus.response?.beneficiarios?.pageSize,
              nextPage: getDocumentosStatus.response?.beneficiarios?.nextPage,
              total: getDocumentosStatus.response?.beneficiarios?.total,
            }}
            paginationParams={paginationParams}
            handleChangePage={handleChangePage}
            setPaginationParams={setPaginationParams}
            handlePageChangeKeyDown={handlePageChangeKeyDown}
          />
        </WrapperFlex>
      </FadeIn>
      <ModalDetalheDocumento
        isOpen={openModalDetalheDocumento.isOpen}
        onRecusar={handleModalMotivoRecusa}
        onAceitar={handleAceitarDocumento}
        onCloseModal={handleOpenModalDetalheDocumento}
        documentoPreview={getDocumentoDetalhe}
        reenviarDocumento={redirectToDetalheLista}
        tipoDocumento={openModalDetalheDocumento.tipoDocumento}
        statusDocumento={openModalDetalheDocumento.statusDocumento}
        idStatusLista={
          getDocumentosStatus.response.lista
            ? getDocumentosStatus.response.lista.idStatus
            : null
        }
      />
      <ModalMotivoRecusa
        isOpen={openModalMotivoRecusa.isOpen}
        idArquivo={openModalMotivoRecusa.idArquivo}
        onClick={handleOpenModalMotivoRecusa}
        onClickEnviar={handleAceitarRecusarDoc}
        hasObrigatoriedadeFile
      />
      <ModalSuccess
        onClick={handleModalSuccess}
        text={openModalSuccess.message}
        isOpen={openModalSuccess.success}
      />
    </Container>
  );
}

export default DetalheDocumentos;
